import { Module } from 'vuex';
import { SystemChangeHistoryState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: SystemChangeHistoryState = {
    userResult: {
        histories: undefined,
        historyCount: 0,
    },
    mailResult: {
        histories: undefined,
        historyCount: 0,
    },
    nodeResult: {
        histories: undefined,
        historyCount: 0,
    },
    systemSettingResult: {
        histories: undefined,
        historyCount: 0,
    },
    accountInventorySettingResult: {
        histories: undefined,
        historyCount: 0,
    },
    user: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    mail: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    node: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    systemSetting: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    accountInventorySetting: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    csv: {
        isProcessing: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

const namespaced: boolean = true;

export const systemChangeHistory: Module<SystemChangeHistoryState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
